export default __webpack_public_path__ + "static/simca-353ff1a57406bb0cfcc6a6ceca7f461e.jpg";